import { render, staticRenderFns } from "./FormatObjectPropertyEditTool.vue?vue&type=template&id=465286b0&scoped=true&"
import script from "./FormatObjectPropertyEditTool.vue?vue&type=script&lang=ts&"
export * from "./FormatObjectPropertyEditTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatObjectPropertyEditTool.vue?vue&type=style&index=0&id=465286b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465286b0",
  null
  
)

export default component.exports